import { render, staticRenderFns } from "./DashboardPrelevements.vue?vue&type=template&id=05e2a0bd&scoped=true&"
import script from "./DashboardPrelevements.vue?vue&type=script&lang=js&"
export * from "./DashboardPrelevements.vue?vue&type=script&lang=js&"
import style0 from "./DashboardPrelevements.vue?vue&type=style&index=0&id=05e2a0bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e2a0bd",
  null
  
)

export default component.exports